// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../demo/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inlineToolbar {\n  z-index: 1;\n  position: absolute;\n  border-radius: 3px;\n  background-color: #FFFFFF;\n  box-shadow: 0 8px 10px -4px rgba(116, 124, 151, 0.4), 0 0 1px 0 rgba(116, 124, 151, 0.4);\n}\n.inlineToolbar__button {\n  padding: 7px 5px;\n}\n", ""]);
// Exports
module.exports = exports;
